import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./index";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "es",
	ns: ["translations"],
	resources: messages,
	interpolation: {
		escapeValue: false,
	},
});


// Export i18n instance
export { i18n };

// Trigger rebuild


